import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from '@mc/i18n'
import { DEFAULT_THUMBNAIL, SITE_NAME } from 'libs/constants'
import { getUrlWithoutQueryParams } from 'libs/utils'

const Meta = () => {
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()

  return (
    <Head>
      <title>{t('terms.meta.title')}</title>
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={t('terms.meta.description')} name='description' />
      <meta content={t('terms.meta.keywords')} name='keywords' />
      <meta content={DEFAULT_THUMBNAIL} property='og:image' />
      <meta content={t('terms.meta.title')} property='og:title' />
      <meta content={t('terms.meta.description')} property='og:description' />
    </Head>
  )
}

export default Meta
